import { Routes, Route } from 'react-router-dom';
import CatalogPage from './pages/CatalogPage';
import AdventureDetailPage from './pages/AdventureDetailPage';
import EmailSentPage from './pages/EmailSentPage';
import EpisodePage from './pages/EpisodePage';
import WaitingPage from './pages/WaitingPage';
import GameCompletePage from './pages/GameCompletePage';
import HighscoresPage from './pages/HighscoresPage';
import ScrollToTop from './components/ScrollToTop';
import { HandsFreeProvider } from './voice/HandsFreeProvider';

function App() {
  return (
    <div className="min-h-screen bg-[#FFFBF5]">
      {/* Hands-free voice controller lives above the routes so its AudioContext
          persists across navigation (fixes audio breaking after a voice-driven
          page change). */}
      <HandsFreeProvider>
        {/* Reset scroll position on every route change so pages always open
            at the top (fixes mobile UX where pages stayed at the previous
            scroll position after navigation). */}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/adventure/:slug" element={<AdventureDetailPage />} />
          <Route path="/check-email" element={<EmailSentPage />} />
          <Route path="/play/:token" element={<EpisodePage />} />
          <Route path="/waiting/:token" element={<WaitingPage />} />
          <Route path="/complete/:token" element={<GameCompletePage />} />
          <Route path="/highscores" element={<HighscoresPage />} />
        </Routes>
      </HandsFreeProvider>
    </div>
  );
}

export default App;
